import SkeletonTable, {SkeletonTableColumnsType} from "../Common/SkeletonTable";
import { Table } from 'antd';
import React from "react";
import {Record, useQueryWithStore} from "react-admin";
import ReactJson from "@microlink/react-json-view";
import {LiveTableWrapper} from "@src/components/Common/tableUtils";
import { spinnerElement } from "./utils";


const ResponseListView = ({ resource_name, columns = [], filters = {} }: { resource_name: string, columns: object[], filters: object }) => {

    const { loaded, data, refetch } = useQueryWithStore({
      type: 'getList',
      resource: resource_name,
      payload: {
        pagination: { page: 1, perPage: 20 },
        sort: { field: 'id', order: 'dsc' },
        filter: filters
      }
    });


  const ExpandedRow = ({ record }: { record: Record }) => {
    return (
      <ReactJson
        src={record.body}
        displayArrayKey={false}
        displayDataTypes={false}
        collapseStringsAfterLength={15}
        name="body"
        displayObjectSize={false}
      />
    )
  }

  if (!loaded) {
    return spinnerElement;
  }

  return (
      <LiveTableWrapper refetch={refetch}>
        <SkeletonTable loading={!loaded} columns={columns as SkeletonTableColumnsType[]}>
          <Table
              rowKey="id"
              columns={columns}
              dataSource={data}
              expandable={{
                expandedRowRender: (record) => <ExpandedRow record={record} />,
                expandRowByClick: true
              }}
          />
        </SkeletonTable>
      </LiveTableWrapper>
  )
}

export default ResponseListView;
